import(/* webpackMode: "eager", webpackExports: ["WorkspaceDispatcher"] */ "/app/src/app/[workspace_name]/_dispatcher/WorkspaceDispatcher.tsx");
